import { TablePagination as AnyUITablePagination, type TablePaginationProps } from '@any-ui-react/core';
import { useScreenBreakpoint } from '@/common/hooks';

export const TablePagination = (props: TablePaginationProps) => {
  const isMediumScreen = useScreenBreakpoint('md');

  return (
    <div className="pt-3">
      <AnyUITablePagination
        {...props}
        classNames={{ control: 'md:first:p-2 md:last:p-2' }}
        withPages={isMediumScreen}
      />
    </div>
  );
};
